import { css } from '@emotion/react';
import { math } from 'polished';
import { BorderLeftRadius, BorderRadius, BorderRightRadius } from './mixins/_border-radius.mixin';
import { ListUnstyled } from './mixins/_lists.mixin';
import { PaginationSize } from './mixins/_pagination.mixin';

export default $ => {
  const rules = [];

  rules.push(css`
    .pagination {
      display: flex;
      ${new ListUnstyled().include($)};
      ${new BorderRadius().include($)};
    }
  `);

  rules.push(css`
    .page-link {
      position: relative;
      display: block;
      padding: ${$.paginationPaddingY} ${$.paginationPaddingX};
      margin-left: ${math(`-${$.paginationBorderWidth}`)};
      line-height: ${$.paginationLineHeight};
      color: ${$.paginationColor};
      text-decoration: ${$.linkDecoration === 'none' ? 'null' : 'none'};
      background-color: ${$.paginationBg};
      border: ${$.paginationBorderWidth} solid ${$.paginationBorderColor};

      &:hover {
        z-index: 2;
        color: ${$.paginationHoverColor};
        text-decoration: none;
        background-color: ${$.paginationHoverBg};
        border-color: ${$.paginationHoverBorderColor};
      }

      &:focus {
        z-index: 3;
        outline: ${$.paginationFocusOutline};
        // box-shadow: ${$.paginationFocusBoxShadow};
      }
    }
  `);

  rules.push(css`
    .page-item {
      &:first-of-type {
        .page-link {
          margin-left: 0;
          ${new BorderLeftRadius($.borderRadius).include($)};
        }
      }
      &:last-child {
        .page-link {
          ${new BorderRightRadius($.borderRadius).include($)};
        }
      }

      &.active .page-link {
        z-index: 3;
        color: ${$.paginationActiveColor};
        background-color: ${$.paginationActiveBg};
        border-color: ${$.paginationActiveBorderColor};
      }

      &.disabled .page-link {
        color: ${$.paginationDisabledColor};
        pointer-events: none;
        // Opinionated: remove the "hand" cursor set previously for .page-link
        cursor: auto;
        background-color: ${$.paginationDisabledBg};
        border-color: ${$.paginationDisabledBorderColor};
      }
    }
  `);

  //
  // Sizing
  //
  rules.push(css`
    .pagination-lg {
      ${new PaginationSize($.paginationPaddingYLg, $.paginationPaddingXLg, $.fontSizeLg, $.lineHeightLg, $.paginationBorderRadiusLg).include($)};
    }
  `);

  rules.push(css`
    .pagination-sm {
      ${new PaginationSize($.paginationPaddingYSm, $.paginationPaddingXSm, $.fontSizeSm, $.lineHeightSm, $.paginationBorderRadiusSm).include($)};
    }
  `);

  return css(rules);
};
